import Dialog from "@mui/material/Dialog";
import { AppTextField, WarningButton, DefaultButton, DeleteButton } from "../form";
import { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import AlertIcon from "../../assets/images/Alert_Icon.png";
import DeleteIcon from "../../assets/images/Alert Delete Icon.png";
import FlexBox from "../layouts/Flexbox";
import { APP_COLORS } from "../../enums";

export default function AlertDialog({
  title = "Alert",
  message,
  onPrimaryActionClick,
  handleClose,
  userInputRequired = false,
  variant = "warning",
  primaryActionLabel = "Yes",
  isPrimaryActionDisabled = false,
}) {
  const [inputField, setInputField] = useState({ value: "", error: true });

  const handleInputChange = (e) => {
    setInputField({
      value: e?.target?.value,
      error: false,
    });
  };

  const handleOnPrimaryActionClick = () => {
    if (userInputRequired) {
      if (!inputField.value) {
        handleInputChange({
          ...inputField,
          error: true,
        });

        return;
      }

      onPrimaryActionClick(inputField?.value);

      return;
    }

    onPrimaryActionClick();
  };

  const { value, error } = inputField;

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      PaperProps={{
        sx: {
          background: variant === "warning" ? 'linear-gradient(180deg, #FFD4BC 0%, #FFFFFF 100%)' : 'linear-gradient(180deg, #FFD7DD 0%, #FFFFFF 100%)',
          p: 3,
          maxWidth: "460px",
        },
      }}
    >
      <Stack gap={3} alignItems="center" justifyContent="space-between" >
        <Box>
          <img height={100} width={100} src={variant === "warning" ? AlertIcon : DeleteIcon} alt="Alert Icon" />
        </Box>
        <Stack justifyContent="center" alignItems="center" gap={1}>
          <Typography variant="heading6-manrope-bold">{title}</Typography>
          <Typography variant="body-ibmPlexMono" color={APP_COLORS.textMedium2}>{message}</Typography>
        </Stack>

        {userInputRequired && (
          <Stack gap={1} width="100%">
            <Typography variant="body-ibmPlexMono-medium">{"Message"}</Typography>
            <AppTextField
              key={`form-alert-user-input`}
              inputProps={{
                id: "alert-input",
                value,
                name: "alertInput",
                onChange: handleInputChange,
                sx: {
                  bgcolor: "transparent",
                }
              }}
              labelProps={{
                label: "",
              }}
              errorProps={{
                error: error,
                required: true,
              }}
            />
          </Stack>
        )}

        <FlexBox gap={1} width="100%">
          <DefaultButton fullWidth onClick={handleClose}>
            Cancel
          </DefaultButton>
          {variant === "warning" ? (
            <WarningButton
              variant="contained"
              fullWidth
              onClick={handleOnPrimaryActionClick}
              autoFocus
              disabled={(userInputRequired && !inputField.value) || isPrimaryActionDisabled}
            >
              {primaryActionLabel}
            </WarningButton>
          ) : (
            <DeleteButton
              variant="contained"
              fullWidth
              onClick={handleOnPrimaryActionClick}
              autoFocus
              disabled={(userInputRequired && !inputField.value) || isPrimaryActionDisabled}
            >
              {primaryActionLabel}
            </DeleteButton>
          )}
        </FlexBox>
      </Stack>
    </Dialog >
  );
}
